import { useEffect, useState } from 'react'
import { fetchSubmissionAuthors } from './api/weekly'

/**
 * avatar_url per profile id for a set of players. Room member rows
 * carry display_name but not the photo, so live-game screens resolve
 * avatars with one extra profiles read. Keyed on the de-duped sorted
 * id list, so realtime ticks that merely reshuffle join order don't
 * refetch. Photos are decorative: on any failure the map stays empty
 * and Avatar falls back to initials.
 */
export function useProfileAvatars(
  profileIds: (string | null | undefined)[],
): Record<string, string | null> {
  const [map, setMap] = useState<Record<string, string | null>>({})
  const key = [...new Set(profileIds.filter((s): s is string => Boolean(s)))].sort().join(',')

  useEffect(() => {
    if (!key) { setMap({}); return }
    let cancelled = false
    fetchSubmissionAuthors(key.split(','))
      .then(m => {
        if (cancelled) return
        setMap(Object.fromEntries(
          Object.entries(m).map(([id, v]) => [id, v.avatar_url]),
        ))
      })
      .catch(() => { /* initials remain */ })
    return () => { cancelled = true }
  }, [key])

  return map
}
